import { configureStore } from '@reduxjs/toolkit';
import {
  persistStore,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';
import logger from 'redux-logger';

import { isDevelopment } from '~utils/index';

import rootReducers from './slices';

const store = configureStore({
  reducer: rootReducers,
  middleware: (getDefaultMiddleware) => {
    const defaultMiddleware = getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    });

    if (isDevelopment) {
      return defaultMiddleware.concat(logger);
    }

    return defaultMiddleware;
  },
  devTools: isDevelopment,
});

export const persitor = persistStore(store);

export default store;
